import { createElementBlock as t, openBlock as e, createElementVNode as r } from "vue";
import c from "./index289.js";
const n = {}, s = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function l(p, o, a, i, m, d) {
  return e(), t("svg", s, o[0] || (o[0] = [
    r("path", {
      fill: "currentColor",
      d: "M12 18.75c3.175 0 5.75-2.557 5.75-5.714v-.124c0-2.269-1.968-5.208-4.667-8.182a1.461 1.461 0 0 0-2.166 0c-2.7 2.974-4.667 5.913-4.667 8.182v.124c0 3.157 2.575 5.714 5.75 5.714Zm0-1.5c-2.349 0-4.25-1.888-4.25-4.214v-.124c0-1.732 1.86-4.509 4.278-7.174L12 5.77l.212.235c2.221 2.493 3.918 5.05 4.032 6.73l.006.177v.124c0 2.326-1.901 4.214-4.25 4.214Z"
    }, null, -1)
  ]));
}
const v = /* @__PURE__ */ c(n, [["render", l]]);
export {
  v as default
};
